import { render, staticRenderFns } from "./TraceabilityAudit.vue?vue&type=template&id=5ae6e9c2&scoped=true&"
import script from "./TraceabilityAudit.vue?vue&type=script&lang=js&"
export * from "./TraceabilityAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae6e9c2",
  null
  
)

export default component.exports